// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.follow-list-page {
  padding: 12px 0;
}

.follow-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.follow-list-item {
  border-bottom: 1px solid var(--border-color);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 16px;
}

.follow-list-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  text-decoration: none;
  color: var(--text-primary);
  transition: background 0.15s;
}

.follow-list-link:hover {
  background: var(--hover-bg);
  text-decoration: none;
}

.follow-list-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.follow-list-name {
  font-size: 15px;
  font-weight: 600;
}

.follow-list-empty,
.follow-list-error {
  padding: 40px 20px;
  text-align: center;
  color: var(--text-secondary);
  font-size: 15px;
}

/* Unfollow button */
.unfollow-btn {
  flex-shrink: 0;
  padding: 6px 14px;
  border-radius: 20px;
  border: 1px solid var(--border-color);
  background: transparent;
  color: var(--text-secondary);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}

.unfollow-btn:hover:not(:disabled) {
  background: var(--error-color, #e53935);
  border-color: var(--error-color, #e53935);
  color: #fff;
}

.unfollow-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Confirm modal */
.unfollow-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.unfollow-modal {
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  padding: 28px 24px 20px;
  width: 320px;
  max-width: 90vw;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.unfollow-modal-text {
  font-size: 16px;
  color: var(--text-primary);
  margin: 0 0 20px;
  text-align: center;
}

.unfollow-modal-actions {
  display: flex;
  gap: 10px;
}

.unfollow-modal-cancel,
.unfollow-modal-confirm {
  flex: 1 1;
  padding: 10px;
  border-radius: 20px;
  border: none;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s;
}

.unfollow-modal-cancel {
  background: var(--bg-secondary);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
}

.unfollow-modal-confirm {
  background: var(--error-color, #e53935);
  color: #fff;
}

.unfollow-modal-cancel:hover,
.unfollow-modal-confirm:hover {
  opacity: 0.85;
}

/* Embedded overrides */
.follow-list-page.embedded {
  padding: 0;
  border-top: none;
}

/* Search Containers */
.follow-local-search-container,
.follow-blockchain-search {
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-color);
  background: var(--bg-secondary);
}

.follow-blockchain-search {
  background: var(--card-bg);
}

.follow-search-title {
  margin: 0 0 12px;
  font-size: 15px;
  color: var(--text-primary);
  font-weight: 600;
}

.follow-search-input {
  width: 100%;
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
}

.follow-search-input:focus {
  border-color: var(--accent-color, #1da1f2);
}

.follow-search-status {
  padding: 12px 0 0;
  font-size: 13px;
  color: var(--text-secondary);
  text-align: center;
}

/* Follow button (used in blockchain search results) */
.follow-btn {
  flex-shrink: 0;
  padding: 6px 14px;
  border-radius: 20px;
  border: 1px solid var(--text-primary);
  background: var(--text-primary);
  color: var(--bg-primary);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s;
}

.follow-btn:hover:not(:disabled) {
  opacity: 0.85;
}

.follow-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.blockchain-results-list {
  margin-top: 12px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  overflow: hidden;
  background: var(--bg-primary);
}

.blockchain-results-list .follow-list-item:last-child {
  border-bottom: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/FollowList.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,uCAAuC;EACvC,WAAW;AACb;;AAEA;;EAEE,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;;EAEE,kBAAkB;EAClB,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,sDAAsD;AACtD;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,+BAA+B;EAC/B,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".follow-list-page {\r\n  padding: 12px 0;\r\n}\r\n\r\n.follow-list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.follow-list-item {\r\n  border-bottom: 1px solid var(--border-color);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding-right: 16px;\r\n}\r\n\r\n.follow-list-link {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 12px 20px;\r\n  text-decoration: none;\r\n  color: var(--text-primary);\r\n  transition: background 0.15s;\r\n}\r\n\r\n.follow-list-link:hover {\r\n  background: var(--hover-bg);\r\n  text-decoration: none;\r\n}\r\n\r\n.follow-list-avatar {\r\n  width: 42px;\r\n  height: 42px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.follow-list-name {\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n}\r\n\r\n.follow-list-empty,\r\n.follow-list-error {\r\n  padding: 40px 20px;\r\n  text-align: center;\r\n  color: var(--text-secondary);\r\n  font-size: 15px;\r\n}\r\n\r\n/* Unfollow button */\r\n.unfollow-btn {\r\n  flex-shrink: 0;\r\n  padding: 6px 14px;\r\n  border-radius: 20px;\r\n  border: 1px solid var(--border-color);\r\n  background: transparent;\r\n  color: var(--text-secondary);\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\r\n}\r\n\r\n.unfollow-btn:hover:not(:disabled) {\r\n  background: var(--error-color, #e53935);\r\n  border-color: var(--error-color, #e53935);\r\n  color: #fff;\r\n}\r\n\r\n.unfollow-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Confirm modal */\r\n.unfollow-modal-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.55);\r\n  z-index: 1000;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.unfollow-modal {\r\n  background: var(--card-bg);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 16px;\r\n  padding: 28px 24px 20px;\r\n  width: 320px;\r\n  max-width: 90vw;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.unfollow-modal-text {\r\n  font-size: 16px;\r\n  color: var(--text-primary);\r\n  margin: 0 0 20px;\r\n  text-align: center;\r\n}\r\n\r\n.unfollow-modal-actions {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.unfollow-modal-cancel,\r\n.unfollow-modal-confirm {\r\n  flex: 1;\r\n  padding: 10px;\r\n  border-radius: 20px;\r\n  border: none;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: opacity 0.15s;\r\n}\r\n\r\n.unfollow-modal-cancel {\r\n  background: var(--bg-secondary);\r\n  color: var(--text-primary);\r\n  border: 1px solid var(--border-color);\r\n}\r\n\r\n.unfollow-modal-confirm {\r\n  background: var(--error-color, #e53935);\r\n  color: #fff;\r\n}\r\n\r\n.unfollow-modal-cancel:hover,\r\n.unfollow-modal-confirm:hover {\r\n  opacity: 0.85;\r\n}\r\n\r\n/* Embedded overrides */\r\n.follow-list-page.embedded {\r\n  padding: 0;\r\n  border-top: none;\r\n}\r\n\r\n/* Search Containers */\r\n.follow-local-search-container,\r\n.follow-blockchain-search {\r\n  padding: 16px 20px;\r\n  border-bottom: 1px solid var(--border-color);\r\n  background: var(--bg-secondary);\r\n}\r\n\r\n.follow-blockchain-search {\r\n  background: var(--card-bg);\r\n}\r\n\r\n.follow-search-title {\r\n  margin: 0 0 12px;\r\n  font-size: 15px;\r\n  color: var(--text-primary);\r\n  font-weight: 600;\r\n}\r\n\r\n.follow-search-input {\r\n  width: 100%;\r\n  padding: 10px 14px;\r\n  border-radius: 8px;\r\n  border: 1px solid var(--border-color);\r\n  background: var(--bg-primary);\r\n  color: var(--text-primary);\r\n  font-size: 14px;\r\n  outline: none;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.follow-search-input:focus {\r\n  border-color: var(--accent-color, #1da1f2);\r\n}\r\n\r\n.follow-search-status {\r\n  padding: 12px 0 0;\r\n  font-size: 13px;\r\n  color: var(--text-secondary);\r\n  text-align: center;\r\n}\r\n\r\n/* Follow button (used in blockchain search results) */\r\n.follow-btn {\r\n  flex-shrink: 0;\r\n  padding: 6px 14px;\r\n  border-radius: 20px;\r\n  border: 1px solid var(--text-primary);\r\n  background: var(--text-primary);\r\n  color: var(--bg-primary);\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: opacity 0.15s;\r\n}\r\n\r\n.follow-btn:hover:not(:disabled) {\r\n  opacity: 0.85;\r\n}\r\n\r\n.follow-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.blockchain-results-list {\r\n  margin-top: 12px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  background: var(--bg-primary);\r\n}\r\n\r\n.blockchain-results-list .follow-list-item:last-child {\r\n  border-bottom: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
